export const DOCUMENTO_TIPOS = {
    PEDIDO: 'pedido',
    REQUISICAO: 'requisicao',
    CUPOM: 'cupom',
    CONTRATO: 'contrato',
    GARANTIA: 'garantia',
    RECIBO: 'recibo',
    INDUSTRIA: 'industria',
    TICKET: 'ticket',
};
